import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { fetchImage } from "../api/photo-upload";

const PersonThumbnail = ({ field: { title, image: profileImage } }) => {
  const [avatar, setAvatar] = useState();

  useEffect(() => {
    if (profileImage) {
      fetchImage(profileImage).then(source => source && setAvatar(source));
    }
  }, []);

  return (
    <div className='person-thumbnail'>
      <div className='img-wrapper'>
        <div className='img-container'>
          {avatar ? (
            <img
              src={avatar}
              data-testid='provider-avatar'
              alt='provider-avatar'
            />
          ) : (
            <div className='img-icon' data-testid='img-icon' />
          )}
        </div>
      </div>
      <div className='description-wrapper'>
        <p>{title}</p>
      </div>
    </div>
  );
};

PersonThumbnail.propTypes = {
  field: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
  ).isRequired
};

export default PersonThumbnail;
